export const SET_REFERENCE = "SET_REFERENCE";
export const RESET_REFERENCE = "RESET_REFERENCE";